<template>
    <div>
        <div class="modal fade" id="themeBrowserModal" tabindex="-1" role="dialog"
             aria-labelledby="themeBrowserModalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="themeBrowserModalLabel">Themes</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close"></button>
                    </div>
                    <div class="modal-body p-0">
                        <theme-container v-if="showThemeBrowser" :view-model="modalState" :current-theme-id="layout.theme_id"
                                         @newThemeEvent="onNewThemeInParent"></theme-container>

                        <div v-else class="p-4" style="min-height: 600px;">

                            <div class="my-2 fs-4">
                                Hi! 👋 Let's create a new theme!
                            </div>

                            <new-theme-wizard :new-theme="newTheme" parent-class="w-100"></new-theme-wizard>
                        </div>


                    </div>
                    <div v-if="modalState.theme" class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">{{confirmButtonLabel}}</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ThemeBrowser from "./ThemeBrowser.vue";
import ThemeSidebar from "./ThemeSidebar.vue";
import ExampleThemeContent from "./ExampleThemeContent.vue";
import ThemeLoader from "../utils/ThemeLoader";
import AppService from "../services/AppService";
import ThemeService from "../services/ThemeService";
import ThemeContainer from "./ThemeContainer.vue";
import NewThemeWizard from "./NewThemeWizard.vue";

export default {
    name: 'ThemeBrowserModal',
    components: {NewThemeWizard, ThemeContainer, ExampleThemeContent, ThemeSidebar, ThemeBrowser},
    props: {
        yesEvent: Function,
        layout: Object
    },
    data() {
        return {
            model: webase.model,
            browseTab: true,
            currentModal: null,
            modalElement: null,
            modalState: {
                theme: null,
                browseTab: true
            },
            service: new ThemeService(),
            showThemeBrowser: true,
            newTheme: webase.utils.theme.newTheme()
        }
    },
    computed: {
        confirmButtonLabel() {
            return this.showThemeBrowser ? `Use ${this.modalState.theme.name} Theme` : 'Finish New Theme'
        },
        isOwner() {
            return this.model.currentUser.id !== null && this.modalState.theme !== null &&
                    this.model.currentUser.id === this.modalState.theme.user_id
        }
    },
    mounted() {
        this.modalElement = document.getElementById('themeBrowserModal')
        this.currentModal = new bootstrap.Modal(this.modalElement)
        this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
        this.currentModal.show()
    },
    beforeUnmount() {
        this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
    },
    methods: {
        onNewThemeInParent() {
            this.newTheme = webase.utils.theme.newTheme()
            this.showThemeBrowser = false
        },
        onModalHidden() {
            this.$emit('noEvent')
        },
        noHandler(e) {
            this.currentModal.hide()
        },
        yesHandler(e) {
            if(!this.showThemeBrowser) {
                let defaultTheme = webase.utils.theme.convertToFullTheme(this.newTheme)
                this.modalState.theme = {...defaultTheme}
                ThemeLoader.previewTheme(this.modalState.theme)
                this.modalState.browseTab = false
                this.showThemeBrowser = true
                return
            }

            if (this.isOwner || this.modalState.theme.id === null) {
                this.saveTheme()
            } else if (this.modalState.theme.id !== null) {
                this.useTheme(this.modalState.theme) // NOTE: there is a risk
            }

            // call the parent's "yesEvent"
            if (this.yesEvent) {
                this.yesEvent()
            }

            // hide the modal
            this.noHandler()
        },
        saveTheme() {
            let theme = this.modalState.theme
            let request = {
                theme: theme
            }

            let promise = theme.id === null ? this.service.create(request) : this.service.update(theme.id, request)
            promise.then((response) => {
                console.log('theme saved and used in app')
                console.log(response)
                this.useTheme(response)
                ThemeLoader.loadThemes()
            }).catch((message) => {
                console.log('error saving theme')
                console.log(message)
            })
        },
        useTheme(theme) {
            this.model.app.theme_id = theme.id
            this.layout.theme_id = theme.id
            webase.utils.ui.injectCss(`themes/${theme.id}`)
            let request = {
                app: {
                    theme_id: theme.id
                }
            }

            let appService = new AppService()
            appService.update(this.model.app.id, request)
        }
    }
}
</script>
